import { render, staticRenderFns } from "./report-member.vue?vue&type=template&id=c67af58e&"
import script from "./report-member.vue?vue&type=script&lang=js&"
export * from "./report-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports